/**
* DevExpress HTML/JS Reporting (designer\controls\metadata\xrTableRow.js)
* Version:  23.1.4
* Build date: Jul 18, 2023
* Copyright (c) 2012 - 2023 Developer Express Inc. ALL RIGHTS RESERVED
* License: https://www.devexpress.com/Support/EULAs/universal.xml
*/
import { accessibleDescription, cells, keepTogether, textAlignment } from './properties/metadata';
import { commonControlProperties, fontGroup } from './properties/metadataGroups';
import { controlScripts } from './properties/scriptMetadata';
import { weight } from './xrTableCell';
export var tableRowSerializationsInfo = [
    weight, textAlignment, keepTogether, controlScripts,
    { propertyName: 'height', displayName: 'Height', localizationId: 'DevExpress.XtraReports.UI.XRControl.Height' },
    cells,
].concat(commonControlProperties, fontGroup).filter(x => x != accessibleDescription);
